import React from "react";
import { Link } from "react-router-dom";

import pohori_1 from "../../public/pohori_sumava/pohori_1.png";
import pohori_2 from "../../public/pohori_sumava/pohori_2.png";
import pohori_3 from "../../public/pohori_sumava/pohori_3.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Sumava = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "pohori dark" : "pohori light"}>
        <div className="container">
          <div className="pohori-container">
            <div className="pohori-image">
              <img src={pohori_1} alt="" />
            </div>
            <div className="pohori-content">
              <h1 className={darkMode ? "dark-text" : "light-text"}>Šumava</h1>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "pohori-trip dark" : "pohori-trip light"}>
        <div className="container">
          <div className="pohori-trip-container">
            <div className="pohori-trip-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Kam se vydat na Šumavě?
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                I když se to nezdá, tak Šumava vám nabídne celou řadu hor a
                vyhlídek, které můžete prozkoumat. Ať už hledáte pohodové pěší
                stezky anebo pořádné výšlapy. Je zde spoustu
                naučných a pohodových stezek, ale taky i vysoké hory, které dají
                zabrat. Z některých vrcholů je možnost vidět i Rakouské Alpy. 
                Šumava má nádhernou a okouzlující přírodu, která stojí za to navštívit
              </p>
              <Link
                className={darkMode ? "dark-button-text" : ""}
                to="/sumava/kamsevydat"
              >
                <span>Více</span>
              </Link>
            </div>
            <div className="pohori-trip-image">
              <img src={pohori_2} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section
        className={darkMode ? "pohori-nature dark" : "pohori-nature light"}
      >
        <div className="container">
          <div className="pohori-nature-container">
            <div className="pohori-nature-image">
              <img src={pohori_3} alt="" />
            </div>
            <div className="pohori-nature-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Příroda na Šumavě
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                CHKO Beskydy je svou rozlohou 1 160 km² největší chráněnou
                krajinnou oblastí v České republice. Naleznete zde původní
                pralesovité porosty, horské louky s výskytem vzácných
                karpatských rostlin a živočichů i unikátní pseudokrasové jevy.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sumava;
